<template>
  <div class="shopping-cart__action-code">
    <!-- <div class="action-code-container">
            <label for="action-code">Code einlösen</label>
            <span>Du hast einen Aktions-Code?</span>
            <div class="action-code-container__input">
                <input type="text" id="action-code" v-model="actionCode" :class="{ 'has-error': error.message, 'has-success': success.message }" />
                <button @click="redeemCode">Einlösen</button>
            </div>
            <p v-if="error" class="error-message">{{ errorMessage }}</p>
            <p v-if="success.message" class="success-message">{{ success.message }}</p>
            <a href="#" class="info-link" @click="showInfo()">Erweiterte Informationen</a>
            <template v-if="infoShown">
                <p class="action-code__info">
                    Mit der Eingabe des Codes werden je nach Aktion Rabatte, Gutscheine oder Geschenkkarten aktiviert: Gebe
                    einfach im oberen Feld deinen Code ein und klicke dann "Einlösen".
                </p>
            </template>
        </div> -->
    <div class="shopping-cart__action-code__header">
      <h2 id="coupon-code-heading">Code einlösen</h2>
      <button type="button" class="icon-span" @click="actionCodeDropdown = !actionCodeDropdown" :aria-labelledby="'coupon-code-heading'" :aria-expanded="actionCodeDropdown === true ? 'true' : 'false'" :aria-controls="'coupon-code-dropdown-content'">
        <span :class="actionCodeDropdown === true ? 'icon icon-chevron-up' : 'icon icon-chevron-down'"></span>
      </button>
    </div>
    <div id="coupon-code-dropdown-content" class="shopping-cart__action-code__content" v-if="actionCodeDropdown">
      <span class="subheadline">Du hast einen Aktions-Code?</span>
      <div class="shopping-cart__action-code__dropdown">
        <div class="shopping-cart__action-code__input" :class="{ 'has-error': error.message, 'has-success': success.message, 'input--focus': hasFocus, }">
          <div class="action-code-input-wrapper">
<!--          <BaseInput type="text" label="TESTING" />-->
            <input
                type="text"
                id="action-code"
                ref="actionCode"
                v-model="actionCode"
                aria-describedby="coupon-code-dropdown-input-error coupon-code-dropdown-input-success" 
                @focus="focus()"
                @blur="blur()"
                :disabled="isActionCodeActivated || disableCouponCode" />
            <button
              v-if="isActionCodeActivated"
              type="button"
              class="action-code-delete"
              aria-label="Code entfernen"
              @click="deleteCode"
              :disabled="disableCouponCode">
              <span class="icon icon-times" aria-hidden="true"></span>
            </button>
            <label @click="focus()" class="label" for="action-code">Dein Aktions-Code (Pflichtfeld)</label>
          </div>
          <button class="shopping-cart__action-code__button" @click="redeemCode" v-if="!isActionCodeActivated" :disabled="disableCouponCode">Einlösen</button>
<!--          <button class="isActionCodeActivated" @click="deleteCode" v-if="isActionCodeActivated" :disabled="disableCouponCode">Code entfernen</button>-->
          <div id="coupon-code-dropdown-input-success" class="message-container message-container__success" v-if="success.message" role="alert" aria-live="polite">
            <p>{{ success.message }} </p>
          </div>
          <span id="coupon-code-dropdown-deleted" class="sr-only" v-if="!isActionCodeActivated && !disableCouponCode" role="alert" aria-live="polite">
            entfernt
          </span>
          <div id="coupon-code-dropdown-input-error" class="message-container message-container__error" v-if="error.message">
            <p>{{ error.message }}</p>
          </div>
        </div>

        <button type="button" href="#action-code__info" class="info-link" @click.prevent="showInfo()" :aria-expanded="infoShown === true ? 'true' : 'false'" :aria-controls="'action-code__info'">Erweiterte Informationen</button>
        <template v-if="infoShown">
          <p id="action-code__info" class="action-code__info">
            Mit der Eingabe des Codes werden je nach Aktion Rabatte, Gutscheine oder Geschenkkarten aktiviert:
            Gebe
            einfach im oberen Feld deinen Code ein und klicke dann "Einlösen".
          </p>
        </template>
      </div>
    </div>
  </div>
</template>
  
<script>
import ShoppingCartService from '@/services/shoppingCartService.js';

export default {
  name: 'ShoppingCartActionCode',
  props: {
    disableCouponCode: {
      type: Boolean,
      required: true
    },
    cartData: {
      type: Object,
      required: true
    },
    getCartData: {
      type: Function,
    }
  },

  data() {
    return {
      isActionCodeActivated: this.cartData.couponCode != null && this.cartData.couponCode != '',
      actionCode: this.cartData.couponCode,
      error: { message: '' },
      errorMessage: '',
      infoShown: false,
      actionCodeDropdown: false,
      success: { message: this.cartData.couponCode && this.cartData.couponCodeHeadline },
      hasFocus: false,
      hadFocus: false,
    };
  },

  mounted() {
    if(this.cartData.couponCode) {
      this.focus()
      this.actionCodeDropdown = true;
      if (!this.cartData.isCouponCodeValidForShoppingCart) {
        this.error.message = 'Der Aktions-Code ist für deinen aktuellen Warenkorb leider nicht gültig.';
        this.success.message = '';
      }
    }
  },

  methods: {
    updateStateWithCartData(newCartData) {
      // Update component state based on the new cart data
      this.isActionCodeActivated = newCartData.couponCode != null && newCartData.couponCode != '';
      this.actionCode = newCartData.couponCode;
      this.success.message = newCartData.couponCode && newCartData.couponCodeHeadline;

      if (!newCartData.isCouponCodeValidForShoppingCart) {
        this.error.message = 'Der Aktions-Code ist für deinen aktuellen Warenkorb leider nicht gültig.';
        this.success.message = '';
      } else {
        this.error.message = '';
      }
    },
    focus() {
      this.hasFocus = true;
      this.$nextTick( () => this.$refs.actionCode.focus());
    },
    blur() {
      this.hasFocus = !!this.actionCode;
      this.hadFocus = true;
    },
    showInfo() {
      this.infoShown = !this.infoShown;
    },
    async redeemCode() {
      try {
        if (!this.actionCode) {
          throw new Error('Bitte geben Sie einen gültigen Code ein.');
        }
        const response = await ShoppingCartService.redeemCouponCode(this.actionCode);

        if (response && response.status.code == 'OK') {
          console.log('Coupon code redeemed successfully');
          await this.$props.getCartData();
          this.isActionCodeActivated = true;
          this.success.message = response.status.message;
        } else if (response && response.status.message == 'Coupon Code Limit exceeded') {
          console.log('Coupon Code Limit exceeded');
          this.error.message = 'Diesen Aktionscode hast du bereits benutzt';
          window.freeLotWarningModal(true);
        } else {
          console.error('Error redeeming coupon code:', response ? response.status : 'Unknown Error');
          this.error.message = response.status.message;
        }

        return response && response.status.code == 'OK'
      } catch (error) {
        this.error.message = error.message;
        this.success.message = '';
      }
    },
    async deleteCode() {
      try {
        const response = await ShoppingCartService.deleteCouponCode(this.actionCode);

        if (response && response.status.code == 'OK') {
          console.log('Coupon code removed successfully');
          await this.$props.getCartData();
          this.isActionCodeActivated = false;
          this.actionCode = '';
          this.success.message = response.status.message;
        } else {
          console.error('Error redeeming coupon code:', response ? response.status : 'Unknown Error');
          this.error.message = response.status.message;
        }
      } catch (error) {
        this.error.message = error.message;
        this.success.message = '';
      }
    },
  },
  
  watch: {
    actionCode() {
      // Reset error and success messages when the input value changes
      this.error.message = '';
      this.success.message = '';
    },
    cartData: {
      deep: true, // Ensures nested properties are also observed
      immediate: false, // Set to true if you want it to run on initialization as well
      handler(newCartData, oldCartData) {
        console.log('cartData changed:', { oldCartData, newCartData });
        this.updateStateWithCartData(newCartData);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.shopping-cart__action-code {
  background-color: var(--color-white);
  font-family: "Aktion Mensch Regular";

  button {    
    &:focus, &:focus-visible {
      outline: 0.125rem solid var(--color-white) !important;
      outline-offset: 0.125rem;
      -webkit-box-shadow: 0 0 0 0.125rem var(--color-form-focus-shadow);
      box-shadow: 0 0 0 0.25rem var(--color-form-focus-shadow);
     } 
     &.icon-span {
      background: transparent;
      border: none;
    } 
  }


  .message-container {
    padding: 16px 32px 16px 16px;
    border-radius: 4px;
    position: relative;
    p {
      font-family: "Aktion Mensch Bold";
      color: var(--color-text);
    }
    &__success {
      background-color: #e6f4f1;
      :before {
        top: 24px;
        right: 0;
        content: "\f121";
        font-family: "icons-webfont";
        position: absolute;
        transform: translate(-50%, -50%);
        height: 16px;
        width: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: green;
      }
    }
    &__error {
      background-color: #e7d0d8;

      .warning {
        top: 24px;
        right: 1px;
        font-family: "Aktion Mensch Bold";
        position: absolute;
        transform: translate(-50%, -50%);
        height: 16px;
        width: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color: white;
        background-color: #b41114;
        border-radius: 50%;
      }

    }
  }

  &__input {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 24px;
    padding: 16px 0 24px;
    position: relative;

    .action-code-input-wrapper {
      position: relative;
    }

    input {
      max-height: 40px;
      font-family: "Aktion Mensch Bold";
      font-size: 16px;
      color: var(--color-text);
      padding: 9px;
      width: 100%;
      color: var(--color-text);
      box-sizing: border-box;
      &:focus-visible {
        outline: 3px solid var(--color-border);
      }
    }

    .action-code-delete {
      position: absolute;
      top: 0;
      right: 0px;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      cursor: pointer;

      .icon {
        font-size: 16px;
        color: var(--color-text);
      }
    }

    &.has-error input {
      border: 1px solid var(--color-red-hover);
    }

    &.input--focus {
      .label {
        transform: translateY(-50%);
        font-size: 12px;
      }
    }

    .label {
      padding: 0;
      background: white;
      position: absolute;
      transition: transform 0.2s ease-in-out, font-size 0.2s ease-in-out;
      color: #565656;
      transform: translateY(50%);
      font-family: "Aktion Mensch Regular", sans-serif;
      font-size: 16px;
      left: 40px;
    }

    @media (min-width: 768px) and (max-width: 1379px) {
      grid-template-columns: repeat(2, 1fr); /* Two columns of equal size */
      grid-auto-rows: min-content;
      grid-gap: 32px;

      & > *:nth-child(3) {
        grid-column-start: 2; /* Start at first column */
        grid-column-end: span 2; /* Span across two columns */
      }
    }

    @media (max-width: 767px) {
    }
  }

  &__content {
    padding: 0 32px 16px 32px;
    .subheadline {
      font-size: 14px;
      color: var(--color-text);
    }
    .info-link {
      font-size: 14px;
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--color-border);
    padding: 16px 32px 17px 32px;
    h2 {
      font-size: 20px;
      font-family: "Aktion Mensch Bold";
      color: var(--color-red);
    }
    .icon-span {
      cursor: pointer;
      .icon {
        font-size: 13px;
        font-weight: bold;
        color: var(--color-text);
      }
    }
  }

  &__button {
    color: var(--color-red);
    background-color: transparent;
    border: 2px solid var(--color-red);
    text-decoration: none;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
    padding: 7px;
    font-size: 1rem;
    min-width: 120px;
    font-family: "Aktion Mensch Bold";
    min-height: 44px;
    cursor: pointer;

    &:hover {
      background-color: var(--color-red);
      color: var(--color-button-text);
    }
  }

  .info-link {
    color: var(--color-text);
    background-color: transparent;
    border: none;
    text-decoration: underline !important;

    &:hover {
      color: var(--color-red);
    }
    &:focus-visible {
      outline: 0.125rem solid var(--color-white) !important;
      outline-offset: 0.125rem;
      -webkit-box-shadow: 0 0 0 0.125rem var(--color-form-focus-shadow);
      box-shadow: 0 0 0 0.25rem var(--color-form-focus-shadow);
    }
  }

  label {
    font-size: 1.5rem;
    font-family: "Aktion Mensch Bold";
    color: var(--color-red);
    margin-bottom: 16px;
    display: inline-block;
  }
}

.action-code-container {
  display: flex;
  flex-direction: column;
  max-width: 600px;
}

.action-code__info {
  margin-top: 16px;
  font-size: 13px;
  line-height: 20px;
  color: var(--color-text);
}

.action-code-container input {
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  font-size: 16px;

  &.has-error {
    border: 1px solid var(--color-red);
  }

  &.has-success {
    border: 1px solid var(--color-green);
  }
}

.action-code-container__input {
  margin-top: 12px;
}

.error-message {
  color: var(--color-red);
  margin-top: 10px;
}

.success-message {
  color: var(--color-green);
  margin-top: 10px;
}

.info-link {
  color: #000;
  text-decoration: none;
  margin-top: 10px;
}
</style>
  